import { ManualVersion } from '../versioning'
import * as adjustments_2020 from './2020/adjustments'
import * as adjustments_2024 from './2024/adjustments'
import * as adjustments_2024_1 from './2024_1/adjustments'

export { adjustments_2020, adjustments_2024, adjustments_2024_1 }

export const getAdjustments = (manualVersion?: ManualVersion) => {
  switch (manualVersion) {
    case '2020':
      return adjustments_2020
    case '2024':
      return adjustments_2024
    case '2024_1':
      return adjustments_2024_1
    default:
      throw new Error(`Unknown manual version: ${manualVersion}`)
  }
}
